interface EmptyStateProps {
	icon: React.ElementType;
	title: string;
	subtitle: string;
}

export function EmptyState({ icon: Icon, title, subtitle }: EmptyStateProps) {
	return (
		<div className="flex flex-col items-center justify-center py-16 text-neutral-500">
			<div className="mb-4 flex size-14 items-center justify-center rounded-2xl bg-neutral-900/50 ring-1 ring-inset ring-white/[0.04]">
				<Icon className="size-6" />
			</div>
			<p className="text-base font-medium text-neutral-400">{title}</p>
			<p className="mt-1 text-sm">{subtitle}</p>
		</div>
	);
}
